import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'

import uploader from '@/components/SimpleUploader/index'

Vue.use(uploader)

import '@/styles/element-variables.scss'
import '@/styles/index.scss'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router/index'
import '@/icons'
import globalComponent from '@/components/globalComponent'
import filters from '@/filters'
import '@/router/routerhook'
import '@/utils/number'

Vue.use(ElementUI, {
  size: 'small'
})

Vue.use(filters)

Vue.use(globalComponent)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
